// The shared tone vocabulary (W1, parity restore). A tone is a JUDGEMENT
// ("this needs attention"), never a raw colour a module picks for itself —
// the three semantic tokens below (`--color-ks-pass/warn/fail`) are the only
// place a tone becomes a colour, so every pill and delta reads the same way
// across both modules.

export type Tone = "critical" | "watch" | "ok" | "neutral";

/** Pill classes for a tone: tinted fill + tone text, never a solid block (Meteoric Phase 0 pill). */
export function tonePillClass(tone: Tone): string {
  if (tone === "critical") return "border-transparent bg-ks-fail/10 text-ks-fail";
  if (tone === "watch") return "border-transparent bg-ks-warn/10 text-ks-warn";
  if (tone === "ok") return "border-transparent bg-ks-pass/10 text-ks-pass";
  return "border-border text-muted-foreground";
}

/** Text colour for a signed movement: up green, down red, flat secondary, null muted. */
export function signTextClass(value: number | null): string {
  if (value === null) return "text-muted-foreground";
  if (value > 0) return "text-ks-pass";
  if (value < 0) return "text-ks-fail";
  return "text-ks-grey-1";
}
